;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection = APP.module('Collection');
	var Model      = APP.module('Model');

	Collection.Rankings = Backbone.Collection.extend({
		api_prefix: '',
		sort_key:   'rank',
		sort_order: false, //ASC

		show_team_rankings: function() {
			return this.setApiUrl('_stats/show_team_rankings');
		},
		show_user_rankings: function() {
			return this.setApiUrl('_stats/show_user_rankings');
		},
		setAvgRoundPoints: function() {
			this.each(function(ranking) {
				var scoreflow = ranking.get('league_scoreflow');

				ranking.set('avg_round_points', _.reduce(scoreflow, function(memo, num) { return memo + num; }, 0)/_.size(scoreflow));
			});

			return this;
		},
		setRankRoundChange: function(round_id) {
			this.each(function(ranking) {
				var rank_history      = ranking.get('rank_history'),
					round_rank_change = 0;

				if (_.size(rank_history) > 1) {
					var rid    = round_id || _.max(_.keys(rank_history)),
						change = rank_history[rid] - rank_history[rid-1];

					if (change != 0) {
						round_rank_change = change > 0 ? -1 : 1;
					}
				}

				ranking.set('round_rank_change', round_rank_change);
			});

			return this;
		},
		showSearchAutocomplete: function(){
			return this.setApiUrl('_stats/show_search_autocomplete');
		},
		showUserRankingsById: function(){
			return this.setApiUrl('_stats/show_user_rankings_by_id');
		}
	});

}(window, APP, Backbone, Marionette, $, _));